export default "__VITE_ASSET__D5y2qoz4__"